import ConfigsModule from '../../configs/configs';
import ServicesModule from '../../services/services';
import FiltersModule from '../../filters/filters';
import template from './variationsForm.jade';
import ResourcesModule from "../../resources/resources";
import countriesEN from "../../configs/localization/countriesEN";

export class VariationsFormController {
  /* @ngInject */
  constructor($filter, $scope, CampaignsResource, $state, $stateParams, Upload, notify, $auth, setProgressBar, featureFlagsHelper, $timeout) {
    this.translate = $filter('translate');
    this.translateWith = $filter('translateWith');
    this.notify = notify;
    this.Upload = Upload;
    this.timezoneName = moment.tz(moment.tz.guess()).format('z Z');
    this.stateParams = $stateParams;
    this.CampaignsResource = CampaignsResource;
    this.setProgressBar = setProgressBar;
    this.language = '--';
    this.size_of_creative_to_add = '';
    this.showNativeVideo = true;//featureFlagsHelper.getFlagByKey('NativeVideo').active;
    this.showTargeting = this.variation.language !== "--" || (this.variation.countries !== undefined && this.variation.countries.length > 0);
    this.bulkCreativesStatusOptions =	[
      {name: 'active', value: true},
      {name: 'inactive', value: false}
    ];

    this.removeVariationOptions =	[
      {name: 'Delete', value: true},
      {name: 'Delete', value: false}
    ];

    this.priorityOptions = [
      {name: 'High', value: true},
      {name: 'Regular', value: false},
    ]

    this.disabledOptions = {
      start_mode_immediate: this.variation.bulkCreativesActive,
      start_mode_dont_start: this.variation.bulkCreativesActive
    };
    let vm = this;
    this.sizeAndTypeOptions =	[
      {name: 'Native Banner', value:'native_banner', creativeType:'Static'},
      {name: 'Native Banner', value:'dynamic_native_banner', creativeType:'Dynamic'},
      {name: 'Video', value:'video', creativeType:'Static'},
      {name: 'Audio', value:'audio', creativeType:'Static'},
      {name: 'MRAID Playable', value:'mraid_playable', creativeType:'Static'},
      {name: '320x100 MRAID Banner', value:'mraid_banner', dimensions: '320x100', creativeType:'Static'},
      {name: '300x250 MRAID Banner', value:'mraid_banner', dimensions: '300x250', creativeType:'Static'},
      {name: '320x50 MRAID Banner', value:'mraid_banner', dimensions: '320x50', creativeType:'Static'},
      {name: '320x480 MRAID Banner', value:'mraid_banner', dimensions: '320x480', creativeType:'Static'},
      {name: '384x60 MRAID Banner', value:'mraid_banner', dimensions: '384x60', creativeType:'Static'},
      {name: '468x60 MRAID Banner', value:'mraid_banner', dimensions: '468x60', creativeType:'Static'},
      {name: '480x320 MRAID Banner', value:'mraid_banner', dimensions: '480x320', creativeType:'Static'},
      {name: '728x90 MRAID Banner', value:'mraid_banner', dimensions: '728x90', creativeType:'Static'},
      {name: '768x1024 MRAID Banner', value:'mraid_banner', dimensions: '768x1024', creativeType:'Static'},
      {name: '1024x768 MRAID Banner', value:'mraid_banner', dimensions: '1024x768', creativeType:'Static'},
      {name: '120x600 Skyscraper', value:'120x600', creativeType:'Static'},
      {name: '160x600 Wide Skyscraper', value:'160x600', creativeType:'Static'},
      {name: '168x28 Medium Image Banner', value:'970x90', creativeType:'Static'},
      {name: '200x200 Mall Square', value:'200x200', creativeType:'Static'},
      {name: '250x250 Square', value:'250x250', creativeType:'Static'},
      {name: '240x400 Vertical Rectangle Banner', value:'240x400', creativeType:'Static'},
      {name: '300x250 Inline Rectangle', value:'300x250', creativeType:'Static'},
      {name: '300x250 Inline Rectangle', value:'300x250_dynamic', creativeType:'Dynamic'},
      {name: '300x50 Mobile Large Banner', value:'300x50', creativeType:'Static'},
      {name: '300x600 Half-Page Ad', value:'300x600', creativeType:'Static'},
      {name: '320x100 Large Mobile Banner', value:'320x100', creativeType:'Static'},
      {name: '320x480 Mobile Interstitial Portrait', value:'320x480', creativeType:'Static'},
      {name: '320x480 Mobile Interstitial Portrait', value:'320x480_dynamic', creativeType:'Dynamic'},
      {name: '320x50 Mobile Leaderboard', value:'320x50', creativeType:'Static'},
      {name: '320x50 Mobile Leaderboard', value:'320x50_dynamic', creativeType:'Dynamic'},
      {name: '336x280 Large Rectangle', value:'336x280', creativeType:'Static'},
      {name: '384x60 Banner', value:'384x60', creativeType:'Static'},
      {name: '360x50 Banner', value:'360x50', creativeType:'Static'},
      {name: '320x568 Banner', value:'320x568', creativeType:'Static'},
      {name: '568x320 Banner', value:'568x320', creativeType:'Static'},
      {name: '360x640 Interstitial Portrait', value:'360x640', creativeType:'Static'},
      {name: '375x50 Banner', value:'375x50', creativeType:'Static'},
      {name: '468x60 Banner', value:'468x60', creativeType:'Static'},
      {name: '480x320 Mobile Interstitial Landscape', value:'480x320', creativeType:'Static'},
      {name: '640x360 Interstitial Landscape', value:'640x360', creativeType:'Static'},
      {name: '728x90 Leaderboard', value:'728x90', creativeType:'Static'},
      {name: '768x1024 Tablet Interstitial Portrait', value:'768x1024', creativeType:'Static'},
      {name: '768x90 Tablet Portrait Banner', value:'768x90', creativeType:'Static'},
      {name: '970x90 Large Leaderboard', value:'970x90', creativeType:'Static'},
      {name: '970x250 Billboard', value:'970x250', creativeType:'Static'},
      {name: '1024x768 Tablet Interstitial Landscape', value:'1024x768', creativeType:'Static'},
      {name: '480x320 MRAID Banner', value:'mraid_banner', dimensions: '480x320', creativeType:'Dynamic'},
      {name: '320x480 MRAID Banner', value:'mraid_banner', dimensions: '320x480', creativeType:'Dynamic'},
      {name: '320x50 MRAID Banner', value:'mraid_banner', dimensions: '320x50', creativeType:'Dynamic'},
      {name: '300x250 MRAID Banner', value:'mraid_banner', dimensions: '300x250', creativeType:'Dynamic'},
      {name: '728x90 MRAID Banner', value:'mraid_banner', dimensions: '728x90', creativeType:'Dynamic'},
      {name: '768x1024 MRAID Banner', value:'mraid_banner', dimensions: '768x1024', creativeType:'Dynamic'},
      {name: '1024x768 MRAID Banner', value:'mraid_banner', dimensions: '1024x768', creativeType:'Dynamic'},
    ];

    if (this.showNativeVideo) {
      this.sizeAndTypeOptions.splice(2,0, {name: 'Native Video', value:'native_video', creativeType:'Static'});
    }

    this.validFileTypes = [
      'image/png',
      'image/jpeg',
      'image/pjpeg',
      'image/gif'
    ];

    this.validVideoFileTypes = [
      'video/mp4'
    ];

    this.validAudioFileTypes = [
      'video/mp4',
      'audio/mpeg',
      'audio/wav'
    ];

    this.validMRaidPlayableFileTypes = [
      'text/html',
      'application/zip',
      'application/x-zip-compressed'
    ];

    let countriesKeys = _.keys(countriesEN);
    this.countryCodePossibleValuesOptions = countriesKeys.map(option => {
      return {
        value: option,
        name: this.translate(`countryCodes.${option}`)
      };
    });

    this.variation.creatives = this.variation.creatives || [];
    this.files = [];
    this.variation.gameCampaigns = [];
    this.markAssociatedCampaigns(this.stateParams.id || this.stateParams.gameId);

    this.languageTypeOptions =	[
      {name: 'Universal', value: '--'},
      {name: 'Arabic', value:'ar'},
      {name: 'Chinese', value:'zh'},
      {name: 'English', value:'en'},
      {name: 'Hindi', value:'hi'},
      {name: 'Indonesian', value:'id'},
      {name: 'Japanese', value:'ja'},
      {name: 'Korean', value:'ko'},
      {name: 'Spanish', value:'es'},
      {name: 'Portuguese', value:'pt'},
      {name: 'German', value:'de'},
      {name: 'French', value:'fr'},
      {name: 'Italian', value:'it'},
      {name: 'Thai', value:'th'},
      {name: 'Cantonese (Hong Kong)', value:'zh'},
      {name: 'Danish', value:'da'},
      {name: 'Norwegian', value:'no'},
      {name: 'Swedish', value:'sv'},
      {name: 'Russian', value:'ru'},
    ];

    $scope.$watch('vm.variation.creatives', (newValue) => {
      this.handleNewCreatives(newValue);
    });

    $scope.$watch('vm.gameCampaigns', (newValue, oldValue) => {
      if (newValue !== oldValue) {
        this.markAssociatedCampaigns();
      }
    });

    $scope.$on('newFileUploaded', (event, newFile, creative, customFileProperty) => {
      if(!customFileProperty) {
        this.setCreativeFile(newFile, creative);
      } else if (customFileProperty === 'nativeAdIcon'){
        this.setNativeAdIconFile(newFile, creative);
      } else if (customFileProperty === 'nativeVideoAdIcon'){
        this.setNativeVideoAdIconFile(newFile, creative);
      } else if (customFileProperty === 'nativeAdMainImg'){
        this.setNativeAdMainImg(newFile, creative);
      } else if (customFileProperty === 'nativeVideoAdMainImg'){
        this.setNativeVideoAdMainImg(newFile, creative);
      } else if (customFileProperty === 'nativeVideoAdMainVideo'){
        this.setNativeVideoAdMainVideo(newFile, creative);
      } else if (customFileProperty === 'mraidPlayableFile'){
        this.setMRaidPlayableAdFile(newFile, creative);
      } else if (customFileProperty === 'mainVideo'){
        this.setVideoAdFile(newFile, creative);
      } else if (customFileProperty === 'mainAudio'){
        this.setAudioAdFile(newFile, creative);
      }
    });
  }

  handleNewCreatives(newCreatives) {
    let areAllCreativesInactive;
    if (newCreatives) {
      if (newCreatives.length) {
        areAllCreativesInactive = _.every(newCreatives, (newCreative) => {
          return newCreative.active === undefined || !newCreative.active;
        });

      } else {
        areAllCreativesInactive = true;
      }

      const isTimeframeActive =
          !!this.variation.start_mode && this.variation.start_mode !== 'dont_start' && !!this.variation.start_date && moment(this.variation.start_date).isBefore(moment(),'minutes')
          && (this.variation.end_mode === 'never' || (!!this.variation.end_date && moment(this.variation.end_date).isAfter(moment(),'minutes')));
      this.variation.bulkCreativesActive = !areAllCreativesInactive && isTimeframeActive;
      if (newCreatives.length) {
        this.disabledOptions = {
          start_mode_immediate: this.variation.id && this.variation.start_mode === 'specific_date' && this.variation.bulkCreativesActive,
          start_mode_dont_start: this.variation.id && this.variation.start_mode === 'specific_date' && this.variation.bulkCreativesActive
        };
      }
    }
  }

  onBulkCreativesActiveChange() {
    if(this.variation.bulkCreativesActive !== undefined) {
      const newValue = !this.variation.bulkCreativesActive
      this.setStatusOfAllCreatives(newValue);
      if (!newValue) {
        _.forEach(this.variation.gameCampaigns, campaign => { campaign.selected = false });
        this.variation.campaign_ids = [];
      }
    }
  }

  markAssociatedCampaigns(){
    const clonedCampaigns = _.cloneDeep(this.gameCampaigns);
    clonedCampaigns.forEach((gameCampaign) => {
      gameCampaign.selected = !!_.find(this.variation.campaign_ids, varCampaignId => varCampaignId === gameCampaign.id);
    })
    this.variation.gameCampaigns = clonedCampaigns;
  }

  handleNewFiles(newFiles){
    if(newFiles) {
      this.setProgressBar(this, newFiles.length, 0);
      angular.forEach(newFiles, (value, key) => {
        this.Upload.imageDimensions(value).then((dimensions) => {
          this.setProgressBar(this, newFiles.length, key + 1);
          let addedEmptyCreative = this.insertNewEmptyCreative(dimensions.width + 'x' + dimensions.height);
          if(addedEmptyCreative){
            this.setCreativeFile(value, addedEmptyCreative);
          }
        });
      })
    }
  }

  setStatusOfAllCreatives(newValue) {
    _.forEach(this.variation.creatives, (creative) => {
      creative.active = newValue;
    });
  }

  areValidDimensions(dimensionsString) {
    return _.filter(this.sizeAndTypeOptions, (option) => {return option.value == dimensionsString;}).length > 0;
  }

  onStartModeChange() {
    if(this.variation.start_mode === 'immediate' && !this.variation.bulkCreativesActive) {
      this.variation.bulkCreativesActive = true;
    }
  }

  insertNewEmptyCreative(creativeTypeString, creativeType = 'Static', dimensions = null) {
    if (creativeTypeString == 'mraid_playable') {
      this.variation.creatives.unshift({ type: 'mraid_playable', is_deleted: false });
    } else if (creativeTypeString == 'mraid_banner') {
      this.variation.creatives.unshift({ type: 'mraid_banner', format: creativeType, size: dimensions, is_deleted: false });
    } else if (creativeTypeString == 'video') {
      this.variation.creatives.unshift({ type: 'video', is_deleted: false });
    } else if (creativeTypeString == 'audio') {
      this.variation.creatives.unshift({ type: 'audio', is_deleted: false });
    } else if (creativeTypeString == 'native_banner') {
      this.variation.creatives.unshift({ type: 'native_banner', format: 'Static', is_deleted: false });
    } else if (creativeTypeString == 'dynamic_native_banner') {
      this.variation.creatives.unshift({ type: 'native_banner', format: 'Dynamic', is_deleted: false }, { type: 'native_banner', format: 'Static', is_deleted: false });
    } else if (creativeTypeString == 'native_video') {
      this.variation.creatives.unshift({ type: 'native_video', is_deleted: false });
    } else if (creativeTypeString == 'dynamic_ad') {
      this.variation.creatives.unshift({ type: 'dynamic_ad', is_deleted: false });
    } else if (creativeTypeString.indexOf("_dynamic") !== -1) {
      this.variation.creatives.unshift({ type: 'banner', format: 'Dynamic', size: creativeTypeString.split("_", 2)[0], is_deleted: false });
      this.variation.creatives[0].definition = ''
      return this.variation.creatives[0];
    } else if(this.areValidDimensions(creativeTypeString)){
        this.variation.creatives.unshift({ type: 'banner', size: creativeTypeString, file: {}, is_deleted: false });
        this.variation.size_of_creative_to_add = '';
        return this.variation.creatives[0];
    } else {
      this.notify.warning('dimensionInvalid', {dimension: creativeTypeString});
    }
    return false;
  }

  setCreativeFile(file, creative) {
    if(file){
      if(_.indexOf(this.validFileTypes, file.type) > -1) {
        this.Upload.imageDimensions(file).then((dimensions) => {
          let dimensionsString = dimensions.width + 'x' + dimensions.height;
          if(dimensionsString == creative.size){
            creative.file = file;
            creative.url = null;
          } else {
            this.notify.warning('dimensionInvalidExpected', {dimension: dimensionsString, expected: creative.size});
          }
        });
      } else {
        this.notify.warning('fileTypeInvalid', {type: file.type});
      }
    }
  }

  setNativeAdIconFile(file, creative) {
    if(file){
      if(_.indexOf(this.validFileTypes, file.type) > -1) {
        this.Upload.imageDimensions(file).then((dimensions) => {
          let dimensionsString = dimensions.width + 'x' + dimensions.height;
          if(dimensionsString == '180x180'){
            creative.nativeAdIcon = file;
            creative.icon_image_url = null;
          } else {
            this.notify.warning('dimensionInvalidExpected', {dimension: dimensionsString, expected: '180x180'});
          }
        });
      } else {
        this.notify.warning('fileTypeInvalid', {type: file.type});
      }
    }
  }

  setNativeAdMainImg(file, creative) {
    if(file){
      if(_.indexOf(this.validFileTypes, file.type) > -1) {
        this.Upload.imageDimensions(file).then((dimensions) => {
          let dimensionsString = dimensions.width + 'x' + dimensions.height;
          if(dimensionsString == '1200x627'){
            creative.nativeAdMainImg = file;
            creative.main_image_url = null;
          } else {
            this.notify.warning('dimensionInvalidExpected', {dimension: dimensionsString, expected: '1200x627'});
          }
        });
      } else {
        this.notify.warning('fileTypeInvalid', {type: file.type});
      }
    }
  }

  setNativeVideoAdIconFile(file, creative) {
    if(file){
      if(_.indexOf(this.validFileTypes, file.type) > -1) {
        this.Upload.imageDimensions(file).then((dimensions) => {
          let dimensionsString = dimensions.width + 'x' + dimensions.height;
          if(dimensionsString == '180x180'){
            creative.nativeVideoAdIcon = file;
            creative.icon_image_url = null;
          } else {
            this.notify.warning('dimensionInvalidExpected', {dimension: dimensionsString, expected: '180x180'});
          }
        });
      } else {
        this.notify.warning('fileTypeInvalid', {type: file.type});
      }
    }
  }

  setNativeVideoAdMainVideo(file, creative) {
      if (file) {
          if (_.indexOf(this.validVideoFileTypes, file.type) > -1) {
            creative.nativeVideoAdMainVideo = file;
          } else {
              this.notify.warning('fileTypeInvalid', {type: file.type});
        }
      }
  }

  setVideoAdFile(file, creative) {
      if (file) {
          if (_.indexOf(this.validVideoFileTypes, file.type) > -1) {
            creative.mainVideo = file;
          } else {
              this.notify.warning('fileTypeInvalid', {type: file.type});
          }
      }
  }

  setAudioAdFile(file, creative) {
      if (file) {
          if (_.indexOf(this.validAudioFileTypes, file.type) > -1) {
            creative.mainAudio = file;
          } else {
              this.notify.warning('fileTypeInvalid', {type: file.type});
          }
      }
  }

  setMRaidPlayableAdFile(file, creative) {
      if (file) {
          if (_.indexOf(this.validMRaidPlayableFileTypes, file.type) > -1) {
            creative.mraidPlayableFile = file;
          } else {
              this.notify.warning('fileTypeInvalid', {type: file.type});
          }
      }
  }

  setNativeVideoAdMainImg(file, creative) {
    if(file){
      if(_.indexOf(this.validFileTypes, file.type) > -1) {
        this.Upload.imageDimensions(file).then((dimensions) => {
          let dimensionsString = dimensions.width + 'x' + dimensions.height;
          if(dimensionsString == '1200x627'){
            creative.nativeVideoAdMainImg = file;
            creative.main_image_url = null;
          } else {
            this.notify.warning('dimensionInvalidExpected', {dimension: dimensionsString, expected: '1200x627'});
          }
        });
      } else {
        this.notify.warning('fileTypeInvalid', {type: file.type});
      }
    }
  }

}

export function VariationsFormComponent() {
  return {
    template,
    controller: VariationsFormController,
    restrict: 'E',
    controllerAs: 'vm',
    scope: {
      campaign: '=',
      variation: '=',
      gameCampaigns: '=',
      disableField: '='
    },
    bindToController: true
  };
};

export default angular.module('app.components.campaigns.variations', [
  'ui.router',
  'ngFileUpload',
  ConfigsModule.name,
  ServicesModule.name,
  FiltersModule.name,
  ResourcesModule.name,
])
  .directive('variationsForm', VariationsFormComponent);



/** WEBPACK FOOTER **
 ** ./src/components/creatives/variationsForm.js
 **/